import queryString from 'query-string';

const getCode = (search) => {
  const parsed = queryString.parse(search);
  return parsed.code || '';
};

export default getCode;
